/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamQuestionLibraryQueryResponse,
  GetApiV1ExamQuestionLibraryQueryParams,
  GetApiV1ExamQuestionLibrary400,
  GetApiV1ExamQuestionLibrary401,
  GetApiV1ExamQuestionLibrary500,
} from "../../types/examQuestionLibraryController/GetApiV1ExamQuestionLibrary.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamQuestionLibrary } from "../../clients/examQuestionLibraryController/getApiV1ExamQuestionLibrary.ts";

export const getApiV1ExamQuestionLibraryQueryKey = (
  params?: GetApiV1ExamQuestionLibraryQueryParams,
) =>
  [
    { url: "/api/v1/exam/question-library" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1ExamQuestionLibraryQueryKey = ReturnType<
  typeof getApiV1ExamQuestionLibraryQueryKey
>;

export function getApiV1ExamQuestionLibraryQueryOptions(
  params?: GetApiV1ExamQuestionLibraryQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamQuestionLibraryQueryKey(params);
  return queryOptions<
    GetApiV1ExamQuestionLibraryQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamQuestionLibrary400
      | GetApiV1ExamQuestionLibrary401
      | GetApiV1ExamQuestionLibrary500
    >,
    GetApiV1ExamQuestionLibraryQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamQuestionLibrary(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna a lista paginada de questões da biblioteca de questões, aplicando filtros de data, disciplina, autor, empresa, tipo de componente, idioma, status e texto. **(Requer Authorization para autenticação)**
 * @summary Listar questões da biblioteca (Requer Authorization para autenticação)
 * {@link /api/v1/exam/question-library}
 */
export function useGetApiV1ExamQuestionLibrary<
  TData = GetApiV1ExamQuestionLibraryQueryResponse,
  TQueryData = GetApiV1ExamQuestionLibraryQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamQuestionLibraryQueryKey,
>(
  params?: GetApiV1ExamQuestionLibraryQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamQuestionLibraryQueryResponse,
        ResponseErrorConfig<
          | GetApiV1ExamQuestionLibrary400
          | GetApiV1ExamQuestionLibrary401
          | GetApiV1ExamQuestionLibrary500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1ExamQuestionLibraryQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1ExamQuestionLibraryQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1ExamQuestionLibrary400
      | GetApiV1ExamQuestionLibrary401
      | GetApiV1ExamQuestionLibrary500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
